import React from 'react'
import { HeadingText, BodyText, Button } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'

function EmailConfirmationAlert({ closeModal, emailURL }) {
  return (
    <>
      <div>
        <div className="confirm-email-card-center-content">
          <div className="confirm-email-card-wrapper">
            <img
              src="https://www.paypalobjects.com/paypal-ui/pictograms/blue/svg/email-blue.svg"
              alt="email-blue"
              style={{ width: '100px' }}
            />
            <HeadingText
              className="confirm-email-card-title"
              size="sm"
              id="email-confirmation-title"
            >
              <Message id="dashboard.confirm.your.email.title" />
            </HeadingText>
            <BodyText
              className="confirm-email-card-subtitle"
              id="email-confirmation-description"
            >
              <Message id="dashboard.confirm.your.email.subtitle" />
            </BodyText>
            <Button
              className="confirm-email-card-link"
              as="a"
              href={emailURL}
              role="button"
              target="_blank"
              onClick={closeModal}
              data-dxa="email_confirmation,redirect,email_confirmation_required"
              data-testid="emailConfirmation"
            >
              <Message id="dashboard.confirm.your.email.link" />
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default EmailConfirmationAlert
